var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"m-header",style:({
      height: _vm.pxOrVw(_vm.extraItem.extras('nav.model')),
      display: _vm.extraItem.extras('nav.display') == 1 ? 'block' : 'none',
    })},[_c('div',{staticClass:"header-inner"},[_c('a',{staticClass:"logo",class:_vm.extraItem.extras('logo.size'),style:({
          display: _vm.extraItem.extras('logo.display') == 1 ? 'block' : 'none',
        }),attrs:{"href":"javascript:;"}},[_c('img',{attrs:{"src":_vm.extraItem.extras('logo.src'),"alt":""}})])])]),_c('div',{staticClass:"banner",style:({
      display: _vm.extraItem.extras('banner.display') == 1 ? 'block' : 'none',
    })},[_c('img',{attrs:{"src":_vm.extraItem.extras('banner.src')
          ? _vm.extraItem.extras('banner.src')
          : _vm.imgUrlObj[_vm.platform]['banner'],"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }